import enterpriseInfo from '@/views/setting/views/enterpriseInfo/enterpriseInfo';
export default enterpriseInfo;